import { BaseService } from '@flint/framework';

export default class EditTopic extends BaseService {
  constructor() {
    super("EDITING_TOPIC_DATA", 'TopicEditStore', true);
  }

  handleEvent(eventName, topic) {
    return this.getClient('vetService').put('/admin-api/topics/', topic);
  }
}